import { render, staticRenderFns } from "./TranslationModeToggle.vue?vue&type=template&id=1eb53cf5&scoped=true&lang=html&"
import script from "./TranslationModeToggle.vue?vue&type=script&lang=js&"
export * from "./TranslationModeToggle.vue?vue&type=script&lang=js&"
import style0 from "./TranslationModeToggle.vue?vue&type=style&index=0&id=1eb53cf5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb53cf5",
  null
  
)

export default component.exports